import * as React from 'react';

import { cn } from '../base/utils';

export interface StatusStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  description?: React.ReactNode;
  presentation?: 'page' | 'panel';
}

/** Product-neutral empty, unavailable and permission state presentation. */
export const StatusState = React.forwardRef<HTMLDivElement, StatusStateProps>(
  ({ title, description, presentation = 'panel', className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        presentation === 'page'
          ? 'flex h-full min-h-0 items-center justify-center p-6'
          : 'rounded-lg border p-8 text-center',
        className,
      )}
      {...props}
    >
      <div className="text-center">
        {presentation === 'page'
          ? <div className="text-5xl font-semibold tracking-tight">{title}</div>
          : <h1 className="text-xl font-semibold">{title}</h1>}
        {description ? <p className="mt-3 text-sm text-muted-foreground">{description}</p> : null}
      </div>
    </div>
  ),
);
StatusState.displayName = 'StatusState';
